import {closeBrackets} from '@codemirror/autocomplete'
import {defaultKeymap, history, historyKeymap} from '@codemirror/commands'
import {javascriptLanguage} from '@codemirror/lang-javascript'
import {
  bracketMatching,
  defaultHighlightStyle,
  indentOnInput,
  syntaxHighlighting,
} from '@codemirror/language'
import {highlightSelectionMatches} from '@codemirror/search'
import {type Extension} from '@codemirror/state'
import {
  drawSelection,
  highlightActiveLine,
  highlightActiveLineGutter,
  highlightSpecialChars,
  keymap,
  lineNumbers,
} from '@codemirror/view'
import {groq} from '@sanity/lezer-groq'

const sharedExtensions: Extension[] = [
  lineNumbers(),
  highlightActiveLine(),
  highlightActiveLineGutter(),
  highlightSelectionMatches(),
  highlightSpecialChars(),
  indentOnInput(),
  bracketMatching(),
  closeBrackets(),
  history(),
  drawSelection(),
  syntaxHighlighting(defaultHighlightStyle, {fallback: true}),
  keymap.of(
    [
      // Override the default keymap for Mod-Enter to not insert a new line, we have a custom event handler for executing queries
      {key: 'Mod-Enter', run: () => true},

      // Add the default keymap and history keymap
      defaultKeymap,
      historyKeymap,
    ]
      .flat()
      .filter(Boolean),
  ),
]

export const groqExtensions: Extension[] = [groq(), ...sharedExtensions]

export const paramsExtensions: Extension[] = [javascriptLanguage, ...sharedExtensions]
